module.exports = __webpack_public_path__ + "static/full-logo-dark-square-dd63dfc467ff0644e000b85375411df1.png";